;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sweetalert = require("sweetalert2");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      user_email: null,
      user_id: null,
      old_pwd: null,
      new_pwd: null,
      confirm_new_pwd: null,
      consumer_secret: null,
      consumer_key: null
    };
  },

  mounted: function mounted() {
    this.consumer_secret = this.$attrs["con_secret"];
    this.consumer_key = this.$attrs["con_key"];
  },
  created: function created() {
    this.user_email = this.$attrs["email"];
    this.user_id = this.$attrs["userid"];
  },
  methods: {
    verifyPwdChange: function verifyPwdChange() {
      if (this.old_pwd == null) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Forgot something ? Enter your current password"
        });
        return;
      }
      if (this.new_pwd == null) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Forgot something ? Enter your new password"
        });
        return;
      }
      if (this.new_pwd.length <= 6) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Password length must be grater than 6"
        });
        return;
      }

      if (this.confirm_new_pwd == null) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Forgot something ? Enter your confirmation password"
        });
        return;
      }
      var result = this.confirm_new_pwd.localeCompare(this.new_pwd);
      if (result) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Your new  and confirmation passwords do not match !"
        });
        return;
      }
      this.commitPwdChange();
    },
    commitPwdChange: function commitPwdChange() {
      var urlIs = "/api/user/pwd/change";
      var api_headers = {
        Authorization: "Bearer some_token"
      };

      var api_params = {
        id: this.user_id,
        old_pwd: this.old_pwd,
        new_pwd: this.new_pwd
      };
      Vue.axios.post(urlIs, api_params, {
        headers: api_headers
      }).then(function (response) {
        if (response.data.status == 422) {
          _sweetalert2.default.fire({
            icon: "error",
            title: "Oops...",
            text: "Something isnt right, did you enter the correct current password ?"
          });
        } else {
          $("#addBankAccountModal .close").click();
          _sweetalert2.default.fire({
            position: "top-end",
            icon: "success",
            title: "Your password has been changed",
            showConfirmButton: false,
            timer: 2500
          });
        }
      }).catch(function (error) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!"
        });
      }).then(function () {});
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.old_pwd),expression:"old_pwd"}],staticClass:"form-control",attrs:{"type":"password"},domProps:{"value":(_vm.old_pwd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.old_pwd=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("New password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.new_pwd),expression:"new_pwd"}],staticClass:"form-control",attrs:{"type":"password","minlength":"6"},domProps:{"value":(_vm.new_pwd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.new_pwd=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Confirm new password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirm_new_pwd),expression:"confirm_new_pwd"}],staticClass:"form-control",attrs:{"type":"password","minlength":"6"},domProps:{"value":(_vm.confirm_new_pwd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.confirm_new_pwd=$event.target.value}}})]),_vm._v(" "),_c('input',{staticClass:"btn btn-primary lift",attrs:{"type":"button","value":"Update Password"},on:{"click":_vm.verifyPwdChange}})])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('h3',{staticClass:"mb-2"},[_vm._v("Password")]),_vm._v(" "),_c('label',{staticClass:"mb-5 text-muted"},[_vm._v("Your password is private. Change or update your password often.")])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-740584d9", __vue__options__)
  } else {
    hotAPI.reload("data-v-740584d9", __vue__options__)
  }
})()}